import { Brand } from '@cbridge-utils/mui-theme';

export interface IBranding {
  brand: Brand;
  /** Browser tab title: a product name, the same in every language */
  title: string;
  logoSrc: string;
  iconHref: string;
}

export const BRANDING: Record<Brand, IBranding> = {
  [Brand.CBridge]: {
    brand: Brand.CBridge,
    title: 'cBridge',
    logoSrc: '/logo_dark.svg',
    iconHref: '/icon.svg',
  },
  [Brand.CAntifraud]: {
    brand: Brand.CAntifraud,
    title: 'cAntifraud',
    logoSrc: '/logo_cantifraud.svg',
    iconHref: '/icon_cantifraud.svg',
  },
};
